module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAAz0lEQVRYR2NkGGDAOMD2M4w6YDQEhl4IGDoG6p/fv/4itXIPySGg5xDQ8/8fA/PlQxsKqeEIshzw7x9DMSMDwwRqOIJsB4B8Tw1HUOQAajiCYgdQ6giqOIASR1DNAeQ6gqoOIMcR1HcAE0Pt5QMbWogtI6jqAEYSLYeGGLFuhagDlYSggghdFzmWU80B5FpOFQdQYjnFDqDUcoocQA3LyXKAjl1gNyPT/4+kZDV8yZzkbGjkEKpy7sDqO6TlHdyqSXYAtSyGmTPqgNEQGA0BACE6diHkrPVEAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_newsCenter.png
// module id = MWs1
// module chunks = 1